import React from "react";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { ROWS_PER_PAGE_OPTIONS } from "services/rowsPerPage";

interface RowsPerPageSelectProps {
  rowsPerPage: number;
  onRowsPerPageChange?: (rowsPerPage: number) => void;
  rowsPerPageOptions?: number[];
}

const RowsPerPageSelect = (props: RowsPerPageSelectProps) => {
  const {
    rowsPerPage,
    onRowsPerPageChange,
    rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,
  } = props;

  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
    const newRowsPerPage = Number(event.target.value);
    onRowsPerPageChange?.(newRowsPerPage);
  };

  return (
    <Box
      data-testid="rows-per-page"
      sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
    >
      <FormControl sx={{ minWidth: 88 }} size="small">
        <Select
          id="rows-per-page-select"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
          inputProps={{ sx: { py: 1, px: 2, minWidth: "32px" } }}
          MenuProps={{ PaperProps: { sx: { p: "0 !important" } } }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography sx={{ display: { xs: "none", md: "flex" } }}>
        Рядків на сторінці
      </Typography>
    </Box>
  );
};

export default RowsPerPageSelect;
